/*global _*/
import React from "react";
import PropTypes from "prop-types";

const propTypes = {
	elementos: PropTypes.array.isRequired,
	onCambiaPagina: PropTypes.func.isRequired,
	paginaInicial: PropTypes.number
};

const defaultProps = {
	paginaInicial: 1
};

class Paginador extends React.Component {
	state = {
		paginador: {}
	}

	componentWillMount() {
		if (this.props.elementos && this.props.elementos.length) {
			this.setPagina(this.props.paginaInicial);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.elementos !== prevProps.elementos) {
			this.setPagina(this.props.paginaInicial);
		}
	}

	setPagina(pagina) {
		var elementos = this.props.elementos;
		var paginador = this.state.paginador;

		if (pagina < 1 || pagina > paginador.totalPaginas) {
			return;
		}

		paginador = this.getPaginador(elementos.length, pagina);

		var paginaElementos = elementos.slice(paginador.indiceInicio, paginador.indiceFin + 1);

		this.setState({ paginador: paginador});

		this.props.onCambiaPagina(paginaElementos);
	}

	getPaginador(totalElementos, paginaActual, tamanioPagina) {
		paginaActual = paginaActual || 1;
		tamanioPagina = tamanioPagina || 4;

		var totalPaginas = Math.ceil(totalElementos / tamanioPagina);
		var paginaInicial, paginaFinal;

		if (totalPaginas <= 10) {
			paginaInicial = 1;
			paginaFinal = totalPaginas;
		} else {
			if (paginaActual <= 6) {
				paginaInicial = 1;
				paginaFinal = 10;
			} else if (paginaActual + 4 >= totalPaginas) {
				paginaInicial = totalPaginas - 9;
				paginaFinal = totalPaginas;
			} else {
				paginaInicial = paginaActual - 5;
				paginaFinal = paginaActual + 4;
			}
		}

		var indiceInicio = (paginaActual -1) * tamanioPagina;
		var indiceFin = Math.min(indiceInicio + tamanioPagina - 1, totalElementos - 1);
		var paginas = _.range(paginaInicial, paginaFinal + 1);

		return {
			totalElementos: totalElementos,
			paginaActual: paginaActual,
			tamanioPagina: tamanioPagina,
			totalPaginas: totalPaginas,
			paginaInicial: paginaInicial,
			paginaFinal: paginaFinal,
			indiceInicio: indiceInicio,
			indiceFin: indiceFin,
			paginas: paginas
		};
	}

	render() {
		var paginador = this.state.paginador;

		if (!paginador.paginas || paginador.paginas.length <= 1) {
			return null;
		}

		return (
			<ul className="paginacion">
				<li className={paginador.paginaActual === 1 ? "disabled": ""}>
					<a onClick={() => this.setPagina(paginador.paginaActual - 1)}>&lt;&lt;</a>
				</li>
				{paginador.paginas.map((pagina, indice) => 
					<li key={indice} className={paginador.paginaActual === pagina ? "active": ""}>
						<a onClick={() => this.setPagina(pagina)}> &bull; </a>
					</li>
				)}
				<li className={paginador.paginaActual === paginador.totalPaginas ? "disabled": ""}>
					<a onClick={() => this.setPagina(paginador.paginaActual + 1)}>&gt;&gt;</a>
				</li>
			</ul>
		);
	}
}

Paginador.propTypes = propTypes;
Paginador.defaultProps = defaultProps;
export default Paginador;




// WEBPACK FOOTER //
// ./src/home/paginador.cmpt.js